module.exports = __webpack_public_path__ + "static/img/facebook_cover_photo_1-removebg-preview.fe024ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook_cover_photo_1-removebg-preview.png
// module id = k9AY
// module chunks = 0